import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const GetAllFavouritesLookup = {
  name: 'getAllFavouritesLookup',
  state: {
    data: [],
    loading: false,
    error: '',
    totalCount: 0,
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data: [],
        totalCount: 0,
      };
    },
    getReceived(state, payload) {
      const arr = payload.data.map((element) => ({
        id: element.id,
        companyName: element.org_name,
      }));

      return {
        ...state,
        data: arr,
        loading: false,
        error: '',
        totalCount: payload.totalCount,
      };
    },
    getRequestFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getAllFavouritesLookup() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const orgId = userInfo?.org_id;
        this.getRequested();
        const url = `savvy/favourite/lookup?userOrgId=${orgId}`;
        const response = await http.get(url);

        this.getReceived({
          data: response.data.data,
          totalCount: response.data.data.length,
        });
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default GetAllFavouritesLookup;
